import React, {useState, useEffect} from 'react'
import BookVendorAppointment from './BookVendorAppointment'
import {VendorServiceTypePersonalTraining} from '../../Services/ServicesConstants'
import Routes from '../../../constants/RouteConstants'
import {FormComponentPropTypes} from '../onboardingTypes'

function BookPersonalTraining(props) {
  return (
    <BookVendorAppointment
      {...props}
      serviceType={VendorServiceTypePersonalTraining}
      viewSingleRoute={Routes.PERSONALTRAINING_VIEW_SINGLE}
    />
  )
}

export default BookPersonalTraining

BookPersonalTraining.propTypes = FormComponentPropTypes
